/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import React, { useState } from 'react';
import './FeaturedVideo.css';

const VIDEO_ID = 'KqmfcS2_hGc';

function FeaturedVideo() {
  const [play, setPlay] = useState(false);

  return (
    <section className="mt-video">
      <div className="mt-container mt-video__head">
        <span className="mt-eyebrow">On Film · Latest Video</span>
        <h2 className="mt-video__title">
          <em>Imágenes</em> que acompañan al sonido.
        </h2>
      </div>

      <div className="mt-container">
        <div className="mt-video__frame">
          {!play ? (
            <>
              <img
                className="mt-video__poster"
                src={`https://i.ytimg.com/vi/${VIDEO_ID}/maxresdefault.jpg`}
                alt="Featured video poster"
                loading="lazy"
                onError={(e) => { e.currentTarget.src = `https://i.ytimg.com/vi/${VIDEO_ID}/hqdefault.jpg`; }}
              />
              <div className="mt-video__glass" aria-hidden="true" />
              <button className="mt-video__play" onClick={() => setPlay(true)} aria-label="Play video">
                <span className="mt-video__playDot" />
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M8 5.5v13l11-6.5-11-6.5Z" fill="currentColor"/>
                </svg>
                <span className="mt-video__playLabel">Play Feature</span>
              </button>
              <div className="mt-video__caption">
                <span>Estreno Oficial</span>
                <span>MasteredTraxVEVO · 2026</span>
              </div>
            </>
          ) : (
            <iframe
              className="mt-video__iframe"
              src={`https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&rel=0`}
              title="Featured Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </div>
      </div>
    </section>
  );
}

export default FeaturedVideo;
